<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-01-06 15:13:53
 * @LastEditors: PF
 * @LastEditTime: 2024-10-21 17:29:51
 * @FilePath: \VUE3\src\components\home\tingkejilu\seePopup.vue
-->

<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm" status-icon>
        <el-row>
          <el-col :span="12" class="lightgreen-box">
            <el-form-item label="班级:" prop="cbh">
              <span>{{banjidata.bjmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item label="课程:" prop="dyzz">
              <span>{{banjidata.kcmc}}</span>
            </el-form-item>
          </el-col>

          <el-col :span="12" class="orange-box">
            <el-form-item label="节次:" prop="cbs">
              <span v-if="banjidata.jc">第{{banjidata.jc}}节</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item prop="csrq" label="地点:">
              <span>{{banjidata.jxcdmcs}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item label="听课日期:" prop="dj">
              <span>{{banjidata.tkrq}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="orange-box" v-for="(domain) in jilumoban" :key="domain.id">
            <!-- [1]单行文本 [2]多行文本 [3]数字 [4]下拉框 [5]单选 [6]多选 [7]日期 [8]日期区间 [99]标签 -->
            <el-form-item v-if="domain.lx === 1" :label="domain.bt">
              <el-input disabled v-model="domain.inputVal" :placeholder="domain.tswz" />
            </el-form-item>
            <el-form-item v-if="domain.lx === 2" :label="domain.bt">
              <el-input disabled type="textarea" v-model="domain.inputVal" :placeholder="domain.tswz" :rows="domain.mrhs" />
            </el-form-item>
            <el-form-item v-if="domain.lx === 3" :label="domain.bt">
              <div class="shu_zi_kuang" :class="!domain.qz && !domain.hz ? 'wu_zhui' : !domain.qz ? 'wu_qian_zhui' : !domain.hz ? 'wu_hou_zhui' : 'you_zhui'">
                <div class="qian_zhui" v-if="domain.qz">{{domain.qz}}</div>
                <el-input disabled v-model="domain.inputVal"></el-input>
                <div class="hou_zhui" v-if="domain.hz">{{domain.hz}}</div>
              </div>
            </el-form-item>
            <el-form-item v-if="domain.lx === 4" :label="domain.bt">
              <el-select disabled v-model="domain.inputVal" :placeholder="domain.tswz">
                <el-option v-for="item in domain.xxs" :key="item.id" :label="item.xxwb" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="domain.lx === 5" :label="domain.bt">
              <el-radio-group disabled v-model="domain.inputVal" :placeholder="domain.tswz">
                <el-radio v-for="(item,index) in domain.xxs" :key="index" :label="item.id">{{ item.xxwb }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="domain.lx === 6" :label="domain.bt" >
              <el-checkbox-group disabled v-model="domain.inputArr" :placeholder="domain.tswz">
                <el-checkbox v-for="item in domain.xxs" :key="item.id" :label="item.id">{{ item.xxwb }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="domain.lx === 7" :label="domain.bt">
              <el-date-picker disabled v-model="domain.inputVal" :type="domain.rqlx === 1 ? 'data' : 'datetime'" :format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :value-format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :placeholder="domain.tswz" style="width: 100%;" />
            </el-form-item>
            <el-form-item v-if="domain.lx === 8" :label="domain.bt" >
              <el-date-picker disabled v-model="domain.inputArr" :type="domain.rqlx === 1 ? 'daterange' : 'datetimerange'" :format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :value-format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :placeholder="domain.tswz" range-separator="-" :start-placeholder="domain.tswz" :end-placeholder="domain.bt2" />
            </el-form-item>
            <el-form-item v-if="domain.lx === 99">
              <p style="width: 100%;color:#909399" :style="'font-size:' + domain.ztdx + ';color:' + domain.ztys + ';text-align:' + domain.dqfs === 2 ? 'center' : domain.dqfs === 3 ? 'right' : domain.dqfs === 4 ? 'justify' : 'left'">
                {{ domain.smwz }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'
const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const jilumoban = ref([])
const banjidata = ref({
  bjmc: '',
  kcmc: '',
  jc: '',
  jxcdmcs: '',
  tkrq: ''
}) // 班级数据
const ruleFormRef = ref(null)
const ruleForm = ref({})
const rules = ref({})

// 选择课程 传过来的最终数据
const gochuanshujvxl = (val, time) => {
  actionPost({ url: '/api/v2/jiaowu/jiaowuxiaolikebiao/detail', data: { id: val.id } }).then((res) => {
    if (res.code === 200) {
      banjidata.value = res.data
      banjidata.value.tkrq = time
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      actionPost({ url: '/api/v2/jiaowu/tingkejilu/' + props.row.id }).then((res) => {
        if (res.code === 200) {
          gochuanshujvxl({ id: res.data.xlbjkbid }, res.data.tkrq)
          gochuanshujvxl({ id: res.data.xlbjkbid }, res.data.tkrq)
          res.data.mbzjs.forEach(item => {
            item.inputVal = item.listBdz[0]
            item.inputArr = item.listBdz
            jilumoban.value.push(item)
          })
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
